package br.com.htms.inspeccaocampo.shared.ui.components

import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp

@Composable
fun CampoFotoRow(
    label: String,
    obrigatorio: Boolean,
    quantidadeFotos: Int,
    onTirarFoto: () -> Unit,
    onAdicionarMais: () -> Unit,
    onAbrirLista: () -> Unit,
    modifier: Modifier = Modifier,
    onGaleria: (() -> Unit)? = null
) {
    var menuOrigem by remember { mutableStateOf(false) }
    val textoBotao = buildString {
        append(label.ifBlank { "Foto" })
        if (obrigatorio) append(" *")
    }

    Row(
        modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        TextButton(
            onClick = {
                if (onGaleria != null) menuOrigem = true else onAdicionarMais()
            }
        ) {
            Text("+")
        }
        Box(modifier = Modifier.weight(1f)) {
            PortalOutlinedButton(
                onClick = {
                    if (onGaleria != null) menuOrigem = true else onTirarFoto()
                },
                modifier = Modifier.fillMaxWidth(),
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary)
            ) {
                Text(
                    textoBotao,
                    textAlign = TextAlign.Center,
                    color = MaterialTheme.colorScheme.primary,
                    style = MaterialTheme.typography.labelLarge
                )
            }
            if (onGaleria != null) {
                DropdownMenu(
                    expanded = menuOrigem,
                    onDismissRequest = { menuOrigem = false }
                ) {
                    DropdownMenuItem(
                        text = { Text("Câmera") },
                        onClick = {
                            menuOrigem = false
                            onTirarFoto()
                        }
                    )
                    DropdownMenuItem(
                        text = { Text("Galeria") },
                        onClick = {
                            menuOrigem = false
                            onGaleria()
                        }
                    )
                }
            }
        }
        if (quantidadeFotos > 0) {
            Surface(
                onClick = onAbrirLista,
                modifier = Modifier.size(36.dp),
                shape = CircleShape,
                color = MaterialTheme.colorScheme.primary
            ) {
                Box(contentAlignment = Alignment.Center) {
                    Text(
                        quantidadeFotos.toString(),
                        color = MaterialTheme.colorScheme.onPrimary,
                        style = MaterialTheme.typography.labelMedium
                    )
                }
            }
        }
    }
}
